<form [formGroup]="searchForm" (submit)="submit()">
    <mat-form-field class="col-8 pr-4 m-0">
        <mat-label>Search by flight number</mat-label>
        <input
            formControlName="flightNumber"
            matInput
            type="text"
            class="input-awb"
            placeholder="Please enter your flight number"
            [readonly]="isLoading"
        />
        <mat-error>
            <app-field-error [field]="'flightNumber'" [messageList]="formErrors['flightNumber']" />
        </mat-error>
    </mat-form-field>
    <mat-form-field class="col-4 m-0">
        <mat-label>Date</mat-label>
        <input matInput formControlName="date" [appDisableControl]="isLoading" [matDatepicker]="pickupDate" />
        <mat-error>
            <app-field-error [field]="'date'" [messageList]="formErrors['date']" />
        </mat-error>
        @if (!isLoading) {
            <mat-datepicker-toggle matSuffix [for]="pickupDate" />
        }
        @if (isLoading) {
            <mat-spinner diameter="24" matSuffix class="me-3" />
        }
        <mat-datepicker #pickupDate />
    </mat-form-field>
    @if (!isCompleted) {
        <button matButton="filled" type="submit" class="w-100 my-4" color="primary" [disabled]="isLoading || disabled">
            {{ isLoading ? 'SEARCHING' : 'SEARCH' }}
            @if (isLoading) {
                <mat-icon matIconPrefix>
                    <mat-spinner diameter="24" />
                </mat-icon>
            }
        </button>
    }
</form>
